
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDIgj2EJouS2jktckChveZe2LSL8_BLhG4",
  authDomain: "airobottrading-5df3a.firebaseapp.com",
  projectId: "airobottrading-5df3a",
  storageBucket: "airobottrading-5df3a.firebasestorage.app",
  messagingSenderId: "809983304775",
  appId: "1:809983304775:web:9f060b1515c981b3c83d62"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Enable offline persistence quietly
if (typeof window !== 'undefined') {
  enableIndexedDbPersistence(db).catch((err) => {
    // These are expected in many preview/multi-tab environments
    if (err.code === 'failed-precondition' || err.code === 'unimplemented') {
      // Squelch these logs as they are non-critical
    } else {
      console.warn('Firestore Persistence:', err.code);
    }
  });
}
